export default "__VITE_ASSET__j6cOQ88k__"